import { axiosCheckPageClient } from "service/checkPageService";

export interface IContentCheckLink {
  link: string;
}

export async function checkPageFacebook(content: IContentCheckLink) {
  try {
    const response = await axiosCheckPageClient.get(
      `/checking-links/checking?access_token=$2y$10$cUxxHgX.Rp6tWvXUISMzdOEddoluQRLx7qmFavol0N06wA2UXyeq.&link=${content.link}`
    );

    return response;
  } catch (error: any) {
    throw error.response?.data;
  }
}
